import { supabase } from '../lib/supabase';

export async function getReviews(taxiStandId: string) {
  try {
    const { data, error } = await supabase
      .from('taxi_stand_reviews')
      .select(`
        id,
        rating,
        comment,
        created_at,
        user:users (
          id,
          full_name,
          email
        )
      `)
      .eq('taxi_stand_id', taxiStandId)
      .eq('status', 'approved')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching reviews:', error);
    throw new Error('Yorumlar yüklenirken bir hata oluştu');
  }
}

export async function createReview(taxiStandId: string, rating: number, comment: string) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      throw new Error('Yorum yapmak için giriş yapmalısınız.');
    }

    const { data, error } = await supabase
      .from('taxi_stand_reviews')
      .insert([
        {
          taxi_stand_id: taxiStandId,
          user_id: user.id,
          rating,
          comment,
          status: 'pending'
        }
      ])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error creating review:', error);
    throw new Error('Yorum gönderilirken bir hata oluştu');
  }
}

export async function getUserReviews() {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      throw new Error('Kullanıcı bulunamadı.');
    }

    const { data, error } = await supabase
      .from('taxi_stand_reviews')
      .select(`
        *,
        taxi_stand:taxi_stands (
          id,
          name,
          address
        )
      `)
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching user reviews:', error);
    throw new Error('Kullanıcı yorumları yüklenirken bir hata oluştu');
  }
}